import * as React           from "react";
import { FC }               from "react";
import * as CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch }      from "react-redux";
import { Button, Form }     from "semantic-ui-react";
import NotifyMessage        from "../../../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository     from "../../../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType           from "../../../../../domain/fundamentals/message/notify/NotifyType";
import ReservationUrl       from "../../../../../domain/reservation/url/ReservationUrl";
import NotifyDataSource     from "../../../../../infrastructure/datasource/notify/NotifyDataSource";

interface Props {
  reservationUrl: ReservationUrl;
  loading: boolean;
}

const ReservationUrlForm: FC<Props> = (props: Props) => {
  const {reservationUrl, loading} = props;
  const notifyRepository: NotifyRepository = new NotifyDataSource(useDispatch());

  return (
    <>
      <Form loading={ loading }>
        <Form.Field>
          <label>予約機能をホームページに入れる</label>
          <p>以下のHTMLをご自身のホームページに貼り付けるだけで、<br/>ご自身のホームページから予約を受け付けることができます。</p>
          <CopyToClipboard
            text={ reservationUrl.toHtml() }
            onCopy={() => notifyRepository.optionalMessage(NotifyType.OPTIONAL_SUCCESS, new NotifyMessage("コピーしました。"))}
          >
            <Button style={ {marginBottom: "1rem"} }>HTMLをコピー</Button>
          </CopyToClipboard>
          <Form.TextArea disabled={ true } value={ reservationUrl.toHtml() }/>
        </Form.Field>
      </Form>
    </>
  );
};

export default ReservationUrlForm;
